module.exports = __webpack_public_path__ + "img/BCorpLogoBlack.fc3b14d2.svg";